<template>
  <div class="timeline_box">
    <el-timeline style="width:40%;">
      <el-timeline-item
        v-for="(activity, index) in activities"
        :key="index"
        placement="top"
        :timestamp="activity.gmtCreated"
      >{{ activity.content }}</el-timeline-item>
    </el-timeline>

    <div style="margin-left: 10px;width:60%;">
      <trajectoryMap style="height:100%" />
    </div>
  </div>
</template>
<script>
import { ajax } from '@/api/ctms'
import trajectoryMap from './trajectoryMap'
export default {
  name: 'Child',
  components: {
    trajectoryMap
  },
  data() {
    return {
      activities: [],
      form: { pageNum: 1, pageSize: 10 },
      isUnload: ''
    }
  },
  created() {},
  methods: {
    // 获取页面信息获取详情信息
    getInfo(cardNo) {
      this.form.orderCode = cardNo
      ajax('/ntocc-ctms-api/ctmsOrderTrace', 'get', this.form)
        .then(data => {
          this.activities = [...data.data.records]
          this.tableData = data.data.records
        })
        .catch(error => {
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
.timeline_box {
  min-height: 100%;
  display: flex;
}

</style>
